import { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';
import { MOPINION_FORM_ID } from '../../../customHooks/useMopinion';

interface CustomWindow extends Window {
  srv?: any;
}

declare let window: CustomWindow;

const openFeedback = () => {
  window.srv?.openModal(true, MOPINION_FORM_ID);
};

const useFeedback = () => {
  const [wasOpenedViaUrl, setWasOpenedViaUrl] = useState(false);
  const isFeedbackRoute = useMatch('/feedback');

  useEffect(() => {
    if (!isFeedbackRoute || !window.srv || wasOpenedViaUrl) return undefined;

    // Delay gives the Mopinion script time to initialise
    const timeoutId = setTimeout(() => {
      setWasOpenedViaUrl(true);
      openFeedback();
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [isFeedbackRoute, wasOpenedViaUrl]);

  useEffect(() => () => window.srv?.closeModal(), []);

  return openFeedback;
};

export default useFeedback;
